import { Component } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { NavController, AlertController, ToastController, ModalController, LoadingController, ViewController, NavParams, DateTime } from 'ionic-angular';

import { LocationPage, DetailImagePage } from '../';

import { Api, User, Reviews, Item, Dokumen } from '@providers/asset/index';

// import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';


@Component({
  selector: 'page-form_areview',
  templateUrl: 'page.html'
})
export class FormReviewPage {

  val : any = [];
  data_user : any = [];
  params: any = [];

  images:any=[];
  url_img:any = 'x';
  base_url='';

  item = {
    id            : '',
    location_name : '',
    location_id   : '',
    asset_name    : '',
    asset_id      : '',
    notes         : '',
    dokument_id   : '',
    generated_name: '',
  }

  constructor(
    public navCtrl         : NavController,
    public toastCtrl       : ToastController,
    public modalCtrl       : ModalController,
    public loadingCtrl     : LoadingController,
    public viewCtrl        : ViewController,
    public alertCtrl       : AlertController,
    public navParams       : NavParams,
    public camera          : Camera,
    public api             : Api,
    public userApi         : User,
    public reviewApi       : Reviews,
    public itemApi         : Item,
    public dokumenApi      : Dokumen
  ) {

    this.base_url = this.api.url;
    this.url_img = this.dokumenApi.file_url;

    this.item.asset_id = navParams.get('asset_id');
    this.item.asset_name = navParams.get('asset_name'); 
    this.item.location_id = navParams.get('location_id'); 
    this.item.location_name = navParams.get('location_name');
    
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    console.log(this.item);
    loading.dismiss();

  }

  
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  viewImage(generated_name) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_img+this.item.generated_name
    });
    profileModal.present();
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      this.item.dokument_id=resp.data.id;
      this.item.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }


  save(){

    let alert = this.alertCtrl.create({
      title: 'Notice',
      subTitle: 'Are you sure want to create this Review ?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
            
          }
        },
        {

          text: 'Yes',
          handler: data => {
            if(this.item.notes == ''){
              this.presentToast('Review Detail can not empty !');
              return;
            }else{
              let loading = this.loadingCtrl.create({
                content: 'Please wait...'
              });
              loading.present();
              let params:any = {
                notes       : this.item.notes,
                location_id : this.item.location_id,
                asset_id    : this.item.asset_id,
                dokument_id : this.item.dokument_id
              };

              this.reviewApi.save(params).subscribe((resp:any) => {      
                loading.dismiss();
                this.navCtrl.popTo( this.navCtrl.getByIndex(1));
                this.presentToast('Review created');
              }, (err) => {
                loading.dismiss();
              });
            }
          }
        }
      ]
    });
    alert.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/form_review/page.ts